module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listContainer"
  }, [_c('div', {
    staticClass: "headerLine"
  }, [_c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.goCreate
    }
  }, [_vm._v("添加商品")])]), _vm._v(" "), _c('div', {
    staticClass: "listView"
  }, [_c('div', {
    staticClass: "listMainView"
  }, [_c('div', {
    staticClass: "listTableView"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "info"
  }, [_vm._l((_vm.displayFields), function(fn) {
    return _c('th', {
      key: fn,
      domProps: {
        "textContent": _vm._s(_vm.fieldVerboseName(fn))
      }
    })
  }), _vm._v(" "), _c('th', [_vm._v("最后更新时间")]), _vm._v(" "), _c('th', [_vm._v("删除")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item, index) {
    return _c('tr', {
      key: item.id
    }, [_vm._l((_vm.displayFields), function(fn, colIndex) {
      return _c('td', {
        key: fn,
        class: {
          link: colIndex == 0
        },
        domProps: {
          "textContent": _vm._s(_vm.modelAdapter.fieldTextDisplay(item, fn, _vm.fieldSpec))
        },
        on: {
          "click": function($event) {
            _vm.goDetail(index, colIndex == 0)
          }
        }
      })
    }), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(item.last_update_timestamp)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          _vm.doDelete(index)
        }
      }
    }, [_vm._v("删除")])], 2)
  }))])]), _vm._v(" "), _c('nav', [_c('ul', {
    staticClass: "pagination"
  }, [(_vm.pagination.has_previous) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.loadPageData(1)
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.pagination.has_previous) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.loadPageData(_vm.pagination.previous_link)
      }
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pagination.page_links), function(no) {
    return _c('li', {
      key: no,
      class: {
        active: _vm.pagination.current_no == no
      },
      on: {
        "click": function($event) {
          _vm.loadPageData(no)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      domProps: {
        "textContent": _vm._s(no)
      }
    })])
  }), _vm._v(" "), (_vm.pagination.has_next) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.loadPageData(_vm.pagination.next_link)
      }
    }
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.pagination.has_next) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.loadPageData(_vm.pagination.page_cnt)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "aria-label": "Next"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    },
    domProps: {
      "textContent": _vm._s('尾页（' + _vm.pagination.page_cnt + '）')
    }
  })])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "listSideMenu"
  }, [_c('div', {
    staticClass: "listSearchView"
  }, [_c('div', {
    staticClass: "input-group-control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "请输入关键词"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn",
    on: {
      "click": function($event) {
        _vm.loadPageData(1)
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "type": "button"
    }
  }, [_vm._v("搜索")])])]), _vm._v(" "), _vm._l((_vm.filterFields), function(filterField) {
    return _c('div', {
      key: filterField['field_name'],
      staticClass: "filter"
    }, [_c('div', {
      staticClass: "filterTitle",
      domProps: {
        "textContent": _vm._s(filterField.verbose_name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "filterOptions"
    }, [_c('div', {
      staticClass: "filterOption",
      class: {
        active: _vm.fieldData[filterField['field_name']] == null
      },
      on: {
        "click": function($event) {
          _vm.setFilterOption(filterField['field_name'], null)
        }
      }
    }, [_vm._v("\n            不限\n          ")]), _vm._v(" "), _vm._l((_vm.fieldData[_vm.modelAdapter.fieldOptionName(filterField)]), function(option) {
      return (filterField['field_type'] != 'BooleanField') ? _c('div', {
        key: option.id,
        staticClass: "filterOption",
        class: {
          active: option.id == _vm.fieldData[filterField['field_name']]
        },
        domProps: {
          "textContent": _vm._s(option.name)
        },
        on: {
          "click": function($event) {
            _vm.setFilterOption(filterField['field_name'], option.id)
          }
        }
      }) : _vm._e()
    }), _vm._v(" "), (filterField['field_type'] == 'BooleanField') ? _c('div', {
      staticClass: "filterOption",
      class: {
        active: _vm.fieldData[filterField['field_name']] === true
      },
      on: {
        "click": function($event) {
          _vm.setFilterOption(filterField['field_name'], true)
        }
      }
    }, [_vm._v("\n            是\n          ")]) : _vm._e(), _vm._v(" "), (filterField['field_type'] == 'BooleanField') ? _c('div', {
      staticClass: "filterOption",
      class: {
        active: _vm.fieldData[filterField['field_name']] === false
      },
      on: {
        "click": function($event) {
          _vm.setFilterOption(filterField['field_name'], false)
        }
      }
    }, [_vm._v("\n            否\n          ")]) : _vm._e()], 2)])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "aria-label": "Previous"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("首页")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "aria-label": "Previous"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "aria-label": "Next"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-119ebfee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ModelListPage.vue
// module id = 364
// module chunks = 1